"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minPriceList = void 0;
/**
 * 各種類ごとの最小金額を含むデータ
 */
exports.minPriceList = [
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 35000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 40000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 45000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白黄',
        unit: '式',
        price: 50000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 45000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 50000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 55000
    },
    {
        type: '駐車場工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白黄',
        unit: '式',
        price: 60000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 42000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 48000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 54000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 54000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 60000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 66000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白黄',
        unit: '式',
        price: 60000
    },
    {
        type: '駐車場工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白黄',
        unit: '式',
        price: 72000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 35000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 40000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 45000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 45000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 50000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 55000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白黄',
        unit: '式',
        price: 50000
    },
    {
        type: '道路工事',
        pavementType: '密粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白黄',
        unit: '式',
        price: 60000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 42000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 48000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白',
        unit: '式',
        price: 54000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 54000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 60000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白',
        unit: '式',
        price: 66000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '昼',
        lineType: '白黄',
        unit: '式',
        price: 60000
    },
    {
        type: '道路工事',
        pavementType: '開粒舗装',
        scale: '小規模一式工事',
        timeZone: '夜',
        lineType: '白黄',
        unit: '式',
        price: 72000
    }
];
